export default {
    MAIN_NAV_DESKTOP_TRANSFORM_Y: 60,
};